import { Property } from "@survey-types/survey.property.types";

export interface ContentAnalysis {
  hasComments: boolean;
  hasAmenities: boolean;
  commentsLength: number;
  amenitiesLength: number;
  totalLength: number;
  strategy: "comments-only" | "amenities-only" | "both-sections" | "no-content";
}

export const analyzeContent = (property: Property): ContentAnalysis => {
  const hasComments = Boolean(property.comments?.trim());
  const hasAmenities = Boolean(property.amenities?.trim());
  const commentsLength = property.comments?.trim().length || 0;
  const amenitiesLength = property.amenities?.trim().length || 0;
  const totalLength = commentsLength + amenitiesLength;

  let strategy: ContentAnalysis["strategy"];
  if (hasComments && hasAmenities) {
    strategy = "both-sections";
  } else if (hasComments) {
    strategy = "comments-only";
  } else if (hasAmenities) {
    strategy = "amenities-only";
  } else {
    strategy = "no-content";
  }
  return {
    hasComments,
    hasAmenities,
    commentsLength,
    amenitiesLength,
    totalLength,
    strategy,
  };
};
/**
 * Calculate the actual space required for content including formatting overhead
 * This should match the calculation in propertyProcessing.ts and pageGeneration.ts
 */
const calculateContentSpaceRequirement = (
  contentLength: number,
  isFirstSection: boolean = false,
): number => {
  let totalSpace = contentLength;
  // Formatting space (padding, margins, etc.)
  totalSpace += 50;
  // Section spacing (if not the first section)
  if (!isFirstSection) {
    totalSpace += 20;
  }
  return totalSpace;
};

export default calculateContentSpaceRequirement;
